import { getLocale } from 'next-intl/server';

import { auth } from '@shared/misc';

// eslint-disable-next-line import/no-cycle
import { getLocalPaths } from '../../utils/data';
import { getLanguagesContent } from '../../utils/hooks/get-languages-content';

import { ProfileDropdown } from './components/profile-dropdown';
import { ProfileDropdownSummary } from './components/profile-dropdown-summary';
import { StatusChip } from './components/status-chip';
import {
  getHeaderContent,
  getHeaderProfileDropdownContent,
  getHeaderNavigationLinks,
} from './graphql';
import { HeaderClient } from './header-client';
import { getNavigationLinksByPageType } from './utils/helpers';

export const Header = async () => {
  const session = await auth();
  const isAuthenticated = session !== null;
  const locale = await getLocale();

  const [languagesCmsContent, cmsContent, headerNavigationLinks, profileDropdownCmsContent, paths] =
    await Promise.all([
      getLanguagesContent(),
      getHeaderContent(),
      getHeaderNavigationLinks(),
      getHeaderProfileDropdownContent(),
      getLocalPaths(),
    ]);

  const navigationItems = await getNavigationLinksByPageType(headerNavigationLinks, locale);

  const statusChipSlot = <StatusChip />;
  const headerContentProps = {
    homeLabel: cmsContent.homeLabel,
    isAuthenticated,
    languagesCmsContent,
    profileDropdownCmsContent,
    profileDropdownSlot: <ProfileDropdown cmsContent={profileDropdownCmsContent} />,
    profileDropdownSummarySlot: (
      <ProfileDropdownSummary
        cmsContent={profileDropdownCmsContent}
        statusChipSlot={statusChipSlot}
      />
    ),
    statusChipSlot,
  };

  return (
    <HeaderClient
      headerContentProps={headerContentProps}
      navigationItems={navigationItems}
      paths={paths}
    />
  );
};
